import axios from 'axios'
import { getAPIService } from '../../getServerHost'

export const keyDelete = async (id: number) => {
  const response = await axios.delete(`${getAPIService}/v2/api/access-keys/${id}`)
  return response.data
}
